import { createContext } from 'react';

export const LayoutContext = createContext({});

export default LayoutContext;
